import React from "react";
import { textInputRender } from "../../utils/components";
import ButtonLink from "./ButtonLink";
import { CustomFieldValidator, CustomFormValidator } from "./Form";
import FormModal from "./FormModal";

type TextInputFormModalProps = {
  name: string;
  label: string;
  initialValue?: string;
  validate?: CustomFormValidator;
  validators: CustomFieldValidator[];
  required: boolean;
  placeholder: any;
  onSubmit: (...args: any[]) => void;
  disabled?: boolean;
};

const TextInputFormModal = ({
  name,
  label,
  initialValue,
  validate,
  validators,
  required,
  placeholder,
  onSubmit,
  disabled = false
}: TextInputFormModalProps) => (
  <FormModal
    fields={[
      {
        name,
        required,
        initialValue,
        validators,
        render: textInputRender(label, placeholder, required)
      }
    ]}
    validate={validate}
    // @ts-ignore: FormModal doesn't have 'required' prop
    required={required}
    size="mini"
    onSubmit={onSubmit}
    submitText={"Save"}
    modalHeader={`Change ${label}`}
    modalTrigger={onClick => (
      <ButtonLink
        className="link"
        style={{ background: "none", border: "none", color: "#4c92df" }}
        onClick={onClick}
        disabled={disabled}
      >
        Change
      </ButtonLink>
    )}
  />
);

export default TextInputFormModal;
